/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import JsBarcode from 'jsbarcode';

interface IDataPrint {
  idvale: string,
  dataemissao: Date;
  totalvale: number
  produtor: string;
  numero: string;
  realizacao: string;
  colaborador: string;
  endereco: string;
  cpf: string;
  rg: string;
}

interface Iitens {
  iditens: string;
  idprod: string;
  idlocalizacao: string;
  qtdsaida: number;
  validade?: string | null;
  qtdentrada: number;
  preco: number;
  un: string;
  conversor: number;
  total: number;
  referencia: string;
  qtdestoque: number;
  filtro: string;
  descricao: string;
  localizacao: string;
  reqvencimento: boolean;
}

interface IgetImpressao {
  idsaida: string;
  idfazenda: string;
  idoperacoes: string;
  idparceiro: string;
  idcultivo: string;
  idpivot: string;
  datalan: Date;
  dataoperacao: Date;
  total: number;
  obs: string;
  venda: boolean;
  nome: string;
  fazenda: string;
  itens: Iitens[];
}

async function PDFReciboVale(dadosrecibo: IDataPrint, dados: IgetImpressao) {

  const numero = require('numero-por-extenso');

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const produtos = dados.itens.map((producao) => {
    return [
      { text: producao.descricao, alignment: 'left', border: [false, false, false, false], fontSize: 10 },
    ];
  });

  const quantidade = dados.itens.map((producao) => {
    return [
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(producao.qtdsaida), alignment: 'right', bold: true,
        border: [false, false, false, false], fontSize: 10
      },
    ];
  });

  const unidade = dados.itens.map((producao) => {
    return [
      { text: producao.un, alignment: 'center', bold: true, border: [false, false, false, false], fontSize: 10 },
    ];
  });

  const preco = dados.itens.map((producao) => {
    return [
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(producao.preco), alignment: 'right', bold: true,
        border: [false, false, false, false], fontSize: 10
      },
    ];
  });

  const total = dados.itens.map((producao) => {
    return [
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(producao.total), alignment: 'right', bold: true,
        border: [false, false, false, false], fontSize: 10
      },
    ];
  });

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const gerarCodigoBarrasBase64 = (textoCodigo: string) => {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, textoCodigo, { format: 'CODE128' });
    return canvas.toDataURL('image/png');
  };

  const imageUrl = process.env.REACT_APP_URL_IMGLOG || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const codigoBarras = gerarCodigoBarrasBase64(dados.idsaida);

  const documentDefinition: TDocumentDefinitions = {

    content: [
      {
        table: {
          widths: [50, 180, 130, 130],
          body: [
            [
              {
                image: imageData,
                width: 50,
                border: [true, true, false, true]
              },
              { text: 'Recibo', fontSize: 25, margin: [0, 10, 0, 0], alignment: 'center', border: [false, true, true, true] },
              { text: 'Valor\n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(dadosrecibo.totalvale), fontSize: 18, alignment: 'center', },
              { text: 'Data\n ' + moment(dadosrecibo.dataemissao).format('DD/MM/YYYY'), fontSize: 18, alignment: 'center', },
            ],
            [
              {
                colSpan: 4,
                text: 'Recebi do:  ' + dadosrecibo.produtor,
                heights: 10,
              },
            ],
            [
              {
                colSpan: 4,
                text: 'CEI: ' + dadosrecibo.numero + '                                           Inscrição Estadual: Isento',
                margin: [0, 5, 0, 5],
                heights: 10,
              },
            ],
            [
              {
                colSpan: 4,
                text: 'a importância de: ' + numero.porExtenso(dadosrecibo.totalvale, numero.estilo.monetario),
                heights: 10,
              },

            ],
            [
              {
                colSpan: 4,
                text: 'em realizações de: ' + dadosrecibo.realizacao,
                heights: 10,
              },

            ],
            [
              {
                colSpan: 4,
                table: {
                  widths: [245, 245],
                  body: [
                    [{ text: '', border: [false, false, false, false], }, 'Pelo Que Damos Plena e Geral Quitação'],
                    [{ text: 'Serviços......' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(0), border: [false, false, false, false], }, { text: 'Nome..: ' + dadosrecibo.colaborador, border: [true, false, true, false] }],
                    [{ text: 'Varbas........' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(0), border: [false, false, false, false], }, { text: 'Local.: São Felix do Coribe-Ba', border: [true, false, true, false], }],
                    [{ text: 'Total.........' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(dadosrecibo.totalvale), border: [false, false, false, false], }, { text: 'CPF...: ' + dadosrecibo.cpf, border: [true, false, true, true], }],
                    [{ text: '', border: [false, false, false, false], }, { text: '___________________________________ \n' + dadosrecibo.colaborador, border: [false, false, false, false], alignment: 'center', margin: [0, 50, 0, 30] }],
                  ]
                },
                border: [true, false, true, false],
              }
            ],
            [
              {
                colSpan: 4,
                text: 'Por ser expressão de verdade, dou quitação pela importância recebida, firmando o presente recibo nesta data.',
                heights: 10,
                fontSize: 9,
                border: [true, false, true, true],
              },
            ],
            [
              {
                text: '',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
            [
              {
                text: '',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
            [
              {
                text: '',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
            [
              {
                text: '',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
            [
              {
                text: '',
                colSpan: 4,
                border: [false, false, false, false],
                heights: 10,
              },
            ],
          ],
        }

      },
      {
        style: 'tableExample',
        table: {
          widths: [90, 420],
          body: [
            [
              {
                image: imageData,
                width: 90,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                style: 'tableExample',
                table: {
                  widths: [200, 218],
                  body: [
                    [
                      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 22, margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO, alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false] },
                      { text: 'PRODUÇÃO E COMERCIALIZACAO', margin: [0, 10, 0, 0], italics: true, bold: true, color: '#008080', fontSize: 13, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Rodovia BA 172, KM 1, nº 80, São Felix do Cobribe - Ba - CEP 47.665-000 - Fone (77) 3491-2455', fontSize: 10, colSpan: 2, border: [false, false, false, true] },
                      {},
                    ],
                    [
                      { text: '', border: [false, false, false, false] },
                      {
                        image: codigoBarras, // Adiciona o código de barras gerado como imagem
                        width: 200,
                        border: [false, false, false, false]
                      },
                    ],
                  ]
                }
              },
            ],
          ]
        }
      },
      {
        style: 'tableExample',
        table: {
          widths: [435, 80],
          body: [
            [
              { text: 'Destinatario', fontSize: 8, border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
            ],
            [
              {
                text: '' + (dados.venda ? (
                  'Colaborador\n' + dadosrecibo.colaborador
                ) : (
                  'FAZENDA\n' + dados.fazenda
                )), alignment: 'left', fontSize: 10
              },
              { text: 'Data Emisão\n' + moment(dados.dataoperacao).format('DD/MM/YYYY'), fontSize: 10, alignment: 'center', },
            ],
          ]
        }
      },

      {
        table: {
          widths: [218, 80, 30, 80, 80],
          heights: [2, 0, 150],
          body: [
            [
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },

            ],
            [
              { text: 'Produtos', margin: [5, 0, 0, 0], alignment: 'left', fontSize: 10 },
              { text: 'Quant.', alignment: 'right', fontSize: 10 },
              { text: 'Unid', alignment: 'center', fontSize: 10 },
              { text: 'Pço Unit', alignment: 'right', fontSize: 10 },
              { text: 'Total R$', alignment: 'right', fontSize: 10 },
            ],
            [
              {
                style: 'tableExample',
                table: {
                  body: [
                    ...produtos
                  ]
                }
              },
              {
                margin: [26, 0, 0, 0],
                table: {
                  body: [
                    ...quantidade
                  ]
                }
              },
              {
                margin: [5, 0, 0, 0],
                table: {
                  body: [
                    ...unidade
                  ]
                }
              },
              {
                margin: [35, 0, 0, 0],
                table: {
                  body: [
                    ...preco
                  ]
                }
              },
              {
                margin: [26, 0, 0, 0],
                table: {
                  body: [
                    ...total
                  ]
                }
              },
            ],
          ]

        },
        // layout: 'lightHorizontalLines'
      },
      {
        style: 'tableExample',
        table: {
          widths: [218, 80, 30, 80, 80],
          heights: [2, 130],
          body: [
            [
              { text: 'Data da Retirada dos Produtos', border: [false, false, false, false] },
              { text: '_____/____/___', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: 'Valor Total', border: [false, false, false, false] },
              {
                text: '' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dados.total),
                alignment: 'right', fontSize: 9, border: [true, false, true, true]
              },
            ]
          ]
        }
      },
    ]
  };


  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default PDFReciboVale;

